import { NgModule } from '@angular/core';
import { AccordionModule } from './accordion/accordion.module';
import { AdaptiveParagraphModule } from './adaptive-paragraph/adaptive-paragraph.module';
import { BenefitModule } from './benefits-container/benefit.module';
import { ButtonLazyModule } from './button-component';
import { CustomLinkModule } from './custom-link/custom-link.module';
import { CustomParagraphModule } from './custom-paragraph/custom-paragraph.module';
import { SlotComponentModule } from './slot-component/slot-component.module';
import { SpoilerContainerModule } from './spoiler-container/spoiler-container.module';
import { TabsLazyModule } from './tabs/tabs-lazy.module';
import { TitleModule } from './title/title.module';

const componentModules = [
  CustomLinkModule,
  TitleModule,
  BenefitModule,
  CustomParagraphModule,
  AccordionModule,
  AdaptiveParagraphModule,
  SlotComponentModule,
  TabsLazyModule,
  ButtonLazyModule,
  SpoilerContainerModule,
];

@NgModule({
  imports: componentModules,
  exports: componentModules,
})
export class SdvorSharedCmsComponentsModule {}
